// Module
var code = "<massia-form form=\"true\" label=\"{{$ctrl.filter.libelle}}\"> <input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.filter.values\"> </massia-form>";
// Exports
module.exports = code;